"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStarburstPath = void 0;
var starburst_1 = require("./starburst");
Object.defineProperty(exports, "getStarburstPath", { enumerable: true, get: function () { return starburst_1.getStarburstPath; } });
//# sourceMappingURL=index.js.map